// Recruiter model
export interface Recruiter {
  id: string;
  firstName: string;
  lastName: string;
  followedPositions: string[];
  watchedPositionCount: number;
  assignedPositionCount: number;
}

export interface FetchRecruiterResponseT {
  data: Recruiter[];
}

// Position model
export type PositionStatus = 'open' | 'closed' | 'archived';

export type LocationScope = 'all' | 'monitered' | 'followed' | 'watched';

export interface PositionFilters {
  searchTerm?: string;
  businessIds?: string[];
  isAllLocationsSelected: boolean;
  positionStatus?: PositionStatus[];
  sortBy?: PositionSort;
  sortOrder?: SortOrder;
  jobCustomNames?: string[];
  isAllJobSelected: boolean;
  positionAccessedType?: LocationScope;
  province?: string[];
  isAllProvinceSelected: boolean;
  city?: string[];
  isAllCitySelected: boolean;
  district?: string[];
  isAllDistrictSelected: boolean;
  postalCode?: string;
  recruiters?: string[];
  limit: number;
  page: number;
}

export type PositionFilterPayload<K extends keyof PositionFilters = keyof PositionFilters> = {
  [P in K]: { key: P; value: PositionFilters[P] };
}[K];

export interface Position {
  id: string;
  business: string;
  businessName: string;
  city: string;
  state: string;
  completeBusinessAddress: string;
  jobTitle: string;
  customName: string;
  assignedRecruiters: { id: string; name: string }[] | null;
  watchedRecruiters: { id: string; name: string }[] | null;
  assignedRecruitersCount: number | null;
  watchedRecruitersCount: number | null;
}
export interface PositionResponse {
  count: number;
  data: Position[];
  from: number | null;
  lastPage: number | null;
  to: number | null;
}

export interface RecruiterFilters {
  search: string;
}
export type RecruiterFilterPayload<K extends keyof RecruiterFilters = keyof RecruiterFilters> = {
  [P in K]: { key: P; value: RecruiterFilters[P] };
}[K];

export type ProvinceCities = Record<string, Record<string, string[]>>;
export type Districts = Record<string, string[]>;
export interface PositionAddressResponse {
  result: {
    provinceCities: ProvinceCities;
    postalCodes: string[];
    districts: Districts;
  };
}

export interface LocationFilterQuery {
  searchQuery?: string;
  page: number;
  limit: number;
  sortBy: 'name';
  sortOrder: 'asc';
}
export type LocationFilterPayload<K extends keyof LocationFilterQuery = keyof LocationFilterQuery> = {
  [P in K]: { key: P; value: LocationFilterQuery[P] };
}[K];

export interface Location {
  id: string;
  locationId: string;
  name: string;
}

export interface BusinessLocationsResponse {
  count: number;
  currentPage: string;
  data: Location[];
  from: number;
  lastPage: number;
  perPage: string;
  to: number;
}

export interface Job {
  id: string;
  jobTitle: Record<string, string>;
}

export type FollowState = 'none' | 'followed' | 'watched';
export enum FollowStateEnum {
  None = 'none',
  Followed = 'followed',
  Watched = 'watched',
}

export enum PositionSort {
  Location = 'location',
  Followed = 'followed',
  Unfollowed = 'unfollowed',
  Watched = 'watched',
  Unwatched = 'unwatched',
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc',
}
